import React from 'react';
import { report } from 'lib/utils/dataReport';
import { ATTA_REPORT } from 'lib/constants/atta';
import Dialog from 'lib/components/DialogV2';
import './index.scss';

export function OrderingDialog() {
  report(ATTA_REPORT.SUBMIT_TIP.SUBMITTING_REQ);
  return (
    <Dialog showClose={false} title="订购申请提交中" customClass='ordering-dialog-v2'>
      <div className="ordering-dialog-v2__text">
        <div>您的订购申请提交中，暂无法领奖,</div>
        <div>请稍后刷新页面查询订购结果。</div>
      </div>
    </Dialog>
  );
}
